var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.$_loading_state
    ? _c(
        "div",
        { staticClass: "dp-brew" },
        [
          _vm.isCurrentHistory
            ? _c("DripPodBrewHistory", {
                attrs: { contents: _vm.historyContents },
              })
            : _vm._e(),
          _vm.isCurrentMyrecipe
            ? _c("DripPodBrewHMyrecipe", {
                attrs: { contents: _vm.myrecipeContents },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }